export const CARGAR_ARTICULO = 'CARGAR_ARTICULO';
export const CARGAR_TRANSFERENCIA = 'CARGAR_TRANSFERENCIA';
export const CARGAR_INGRESOBODEGA = 'CARGAR_INGRESOBODEGA';
export const CARGAR_EGRESOBODEGA = 'CARGAR_EGRESOBODEGA';
export const CARGAR_ARTICULOS = 'CARGAR_ARTICULOS';
export const CARGAR_STOCKSARTICULO = 'CARGAR_STOCKSARTICULO';
export const CARGAR_RESERVASARTICULO = 'CARGAR_RESERVASARTICULO';